import { makeStyles } from '@material-ui/core';

const useBidBuyStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.only('md')]: {
      flexDirection: 'column',
    },
  },
  bidBuy: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    height: '100%',
    width: '100%',
  },
  printHide: {
    '@media print': {
      display: 'none',
    },
  },
  headlineWrapper: {
    marginBottom: theme.spacing(2),
  },
  bidAlerts: {
    marginBlockStart: theme.spacing(2),
    marginBlockEnd: theme.spacing(2),
  },
  credentialAlert: {
    marginBlockStart: theme.spacing(2),
    marginBlockEnd: theme.spacing(2),
  },
  select: {
    width: '100%',
  },
}));

export default useBidBuyStyles;
